import React from 'react';
import { BasicInput, FieldInputProps } from './BasicInput';

export const StringInput = (props: FieldInputProps<string>): JSX.Element => {
  return <BasicInput inputType="text" {...props} />;
};
